import gql from 'graphql-tag';

import { AlbumPurchasedEventAddonDetails } from '../../../../../../graphql/fragments/album';
import { AlbumFolderPurchasedEventAddonDetails } from '../../../../../../graphql/fragments/album-folder';

export const AlbumFolderForPurchasedEventAddonFeature = gql`
  query AlbumFolderForPurchasedEventAddonFeature($id: RecordID!) {
    albumFolder(id: $id) {
      id
      album_type
      album_subtype
      ...AlbumFolderPurchasedEventAddonDetails
      __typename
    }
  }
  ${AlbumFolderPurchasedEventAddonDetails}
`;

export const AlbumFolderForPurchasedEventAddonFeatureContributors = gql`
  query AlbumFolderForPurchasedEventAddonFeatureContributors($id: RecordID!) {
    albumFolder(id: $id) {
      id
      is_owner
      album_type
      album_subtype
      purchased_event_addon_types
      __typename
    }
  }
`;

export const AlbumForPurchasedEventAddonFeature = gql`
  query albumForPurchasedEventAddonFeature($id: RecordID!) {
    album(id: $id) {
      id
      album_type
      album_subtype
      ...AlbumPurchasedEventAddonDetails
      __typename
    }
  }
  ${AlbumPurchasedEventAddonDetails}
`;

export const AlbumForPurchasedEventAddonFeatureContributors = gql`
  query AlbumForPurchasedEventAddonFeatureContributors($id: RecordID!) {
    album(id: $id) {
      id
      is_owner
      album_type
      album_subtype
      purchased_event_addon_types
      root_album_folder {
        id
        purchased_event_addon_types
      }
      __typename
    }
  }
`;
